import React, { FunctionComponent } from 'react'
import { Descriptions, Typography } from 'antd'
import { convertDMS } from '../../../utils/coordinate'
import { formatTimestamp } from '../../../utils/time'
import { useLoaderData, useMatch } from '@tanstack/react-router'

const VehicleLocationDetails: FunctionComponent<any> = () => {
  const match = useMatch({ strict: false })
  const { vehicleLocations } = useLoaderData({ from: match.routeId ?? '/' })
  const vehicleLocation = vehicleLocations[0]
  return (
    <Descriptions title={'Location Data'} column={1}>
      <Descriptions.Item label={'Vehicle Location ID'}>
          <Typography.Text>{vehicleLocation?.vehicle_location_id}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Latitude'}>
          <Typography.Text copyable={true}>{vehicleLocation?.latitude}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Longitude'}>
          <Typography.Text copyable={true}>{vehicleLocation?.longitude}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'DMS'}>
          <Typography.Text copyable={true}>
            {convertDMS(vehicleLocation?.latitude, vehicleLocation?.longitude)}
          </Typography.Text>
      </Descriptions.Item>

      {vehicleLocation?.speed ? <Descriptions.Item label={'Speed'}>
          <Typography.Text>{vehicleLocation?.speed}</Typography.Text>
      </Descriptions.Item> : null}

      {vehicleLocation?.heading ? <Descriptions.Item label={'Heading'}>
          <Typography.Text>{vehicleLocation?.heading}</Typography.Text>
      </Descriptions.Item> : null}

      {vehicleLocation?.status ? <Descriptions.Item label={'Status'}>
          <Typography.Text>{vehicleLocation?.status}</Typography.Text>
      </Descriptions.Item> : null}

      {vehicleLocation?.status_detail ? <Descriptions.Item label={'Status Detail'}>
          <Typography.Text>{vehicleLocation?.status_detail}</Typography.Text>
      </Descriptions.Item> : null}

      <Descriptions.Item label={'Update Received'}>
          <Typography.Text>{formatTimestamp(vehicleLocation?.update_received)}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Created At'}>
          <Typography.Text>{formatTimestamp(vehicleLocation?.created_at)}</Typography.Text>
      </Descriptions.Item>

      <Descriptions.Item label={'Updated At'}>
          <Typography.Text>{formatTimestamp(vehicleLocation?.updated_at)}</Typography.Text>
      </Descriptions.Item>
    </Descriptions>
  )
}

export default VehicleLocationDetails
